/**
 * Created by JackCui on 2021/1/11
 */

import jsonLogic from './jsonLogic'
import {apiNameJoin, varDataHandle, sortEventHandle, expressValue} from './utils'

/**
 * 规则校验执行函数
 * @param expressModel
 * @param varMap
 * @returns {null|*|undefined}
 */
export function parsing ({ruleMode, varMap}) {
  const varMapCopy = apiNameJoin(varMap)
  // 处理express model
  const {jsonRules, varDataMap} = ruleMode
  // 处理全部变量 无值的变量请求接口
  const data = varDataHandle(varDataMap, varMapCopy)
  let dataKeys = varMapCopy

  // 判断是否有隐藏字段
  if (data.length) {
    dataKeys = {
      ...varMapCopy,
      ...expressValue(data)
    }
  }
  return jsonLogic.apply(jsonRules, dataKeys)
}

/**
 * 执行当前页面的全部规则
 * @param pageDriven
 * @param varMap
 * @param dispatch
 * @returns {function(...[*]=)}
 */
export const rulesHandle = ({pageDriven, varMap, dispatch}) => {
  return () => {
    const {validEvent, pushItem} = sortEventHandle()

    // 感觉全部规则列表收集全部规则分为 满足条件和不满足条件
    // 然后对条件列表分别排序
    pageDriven.forEach(({eventsMode, ruleMode}) => {
      const bool = parsing({ruleMode, varMap})
      pushItem(bool, ...eventsMode)
    })

    // 根据排序后的条件集合依次触发事件
    for (let i = 0; i < validEvent.length; i++) {
      for (let k = 0; k < validEvent[i].length; k++) {
        const {eventType, fieldApiName, objectApiName, ruleErrorCodeList = []} = validEvent[i][k]

        // ruleErrorCodeList中有元素则跳过当前事件
        if (ruleErrorCodeList.length) continue

        if (typeof eventType === 'function') {
          eventType(varMap[objectApiName], validEvent[i][k])
          continue
        }

        // 派发事件
        // 这里拼接了标识以确定哪些dispatch事件是规则触发的
        dispatch({
          type: eventType,
          eventType,
          objectApiName,
          statusParam: {
            apiName: fieldApiName,
            flag: !!i
          }
        })
      }
    }
  }
}
